<template>
  <img
    v-if="isTop"
    class="top-10-sticker"
    :src="`/img/top-ten/circled-${position}.png`"
  />
  <div
    v-if="assetData"
    class="vertical-slider-card"
    v-bind:class="{ 'is-top': isTop }"
  >
    <router-link :to="url" @click.prevent.stop="openUrl">
      <lazy-image
        type="poster"
        v-if="assetData"
        :src="assetData.thumbnail"
        :title="assetData.title"
        :alt="assetData.title"
      />
    </router-link>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { AssetStore } from "@/stores/assetStore";
import { GenresStore } from "@/stores/genresStore";
import IconPlayFill from "@/components/icons/iconPlayFill.vue";
import IconPlus from "@/components/icons/iconPlus.vue";
import LazyImage from "@/components/utils/LaziImage.vue";

export default {
  name: "VerticalSliderCard",
  components: { LazyImage, IconPlus, IconPlayFill },
  props: {
    asset: {
      type: String,
      default: null,
    },
    isTop: {
      type: Boolean,
      default: false,
    },
    position: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    openUrl() {
      this.$router.push(this.url);
    },
  },
  computed: {
    ...mapState(AssetStore, ["getAssetData"]),
    ...mapState(GenresStore, ["getGenre"]),
    url() {
      let url = this.$t("movie_route", { slug: this.assetData.slug });
      if (this.assetData.type === "series") {
        url = this.$t("serie_route", { slug: this.assetData.slug });
      }
      return url;
    },
    assetData() {
      return this.getAssetData(this.asset);
    },
    metadata() {
      let m = [];
      if (this.assetData.year !== null) {
        m.push(this.assetData.year);
      }
      if (this.assetData.length !== null) {
        m.push(this.assetData.length);
      }

      let genres = this.assetData.genres.map((genre) => {
        return this.getGenre(genre);
      });
      m.push(genres.join(", "));
      // 2019 ‧ 2h 2m ‧ Thriller/Crime
      return m.join(" ‧ ");
    },
  },
};
</script>

<style lang="scss">
.vertical-slider-card {
  cursor: pointer;
  transition: all 0.1s ease-in-out;

  //&:hover{
  //    transform: scale(1.1);
  //    transition: all 0.1s ease-in-out;
  //}
  border-radius: 16px;
  overflow: hidden;
  margin: 1em 0em 1em 1em;
}
.is-top {
  margin-top: 1.5em !important;
}
.top-10-sticker {
  position: absolute;
  top: 0px;
  left: 34%;
  z-index: 1;
  width: 34%;
  height: auto;
}
</style>
